import { RenderTargetWrapper } from "../renderTargetWrapper";

/** @internal */
export class WebGPURenderTargetWrapper extends RenderTargetWrapper {
    /** @internal */
    public _defaultAttachments: number[];
}
